module.exports = __webpack_public_path__ + "img/上海衡山虹妇幼医院.8493090.png";